import Dropzone from 'react-dropzone'
import PreviewThumbs from './PreviewThumb'
import RejectedFilesList from './RejectedFilesList'
import Button from '../../../../general/Button'
import Translation from '../../../../Translation/cont/Translation'

const ImageUploadComponent = ({filesAccepted, filesRejected, transIds, accept, refDropzone, isDisabled, onDrop, onCancel, onUpload, hideAdditionalText, autoUpload}) => {
    const resetDefaultStyles= {}
    const filesAcceptedExist = filesAccepted.length > 0 
    const filesRejectedExist = filesRejected.length > 0
    const filesExist = filesAcceptedExist ||  filesRejectedExist
    const { textAccept, textRejectedList, textInDropzone, textButtonOpenFileDialog, textButtonDeleteFiles, textButtonUploadFiles } = transIds
    let spanClass = ''

    if(filesExist && filesAcceptedExist) {
        spanClass = ' shorter-dropzone'
    }

    return (
        <div className="images-upload">
            <div className="images-upload-dropzone-wrapper image-display-upload">
                <div className={"images-upload-dropzone" + spanClass}>
                    <Dropzone
                        multiple={false}
                        ref={refDropzone}
                        onDrop={onDrop}
                        maxSize={2000000}
                        onFileDialogCancel={onCancel}
                        accept={accept}
                        className={"images-upload-dropzone" + spanClass}
                        acceptClassName="image-upload-accept"
                        acceptStyle= {resetDefaultStyles}
                        rejectClassName="image-upload-reject"
                        rejectStyle={resetDefaultStyles}
                        activeClassName="image-upload-active"
                        activeStyle={resetDefaultStyles}
                    >
                        {({getRootProps, getInputProps}) => {
                            return (
                                <div {...getRootProps()}>
                                    <input {...getInputProps()} />  
                                    {!filesExist && <p><Translation id={textInDropzone[0]}/></p>}
                                    {!filesExist && !hideAdditionalText && <p><Translation id={textAccept[0]}/></p>}
                
                                    {filesAcceptedExist && <PreviewThumbs files={filesAccepted} />}
                                    {filesRejectedExist && <RejectedFilesList files={filesRejected} transId={textRejectedList[0]} />}
                                </div>
                            )
                        }}
                    </Dropzone>
                </div>

                {(!filesExist || (autoUpload && !filesAcceptedExist)) && <Button
                    className="images-upload-button-dialog"
                    transId={textButtonOpenFileDialog[0]}
                    onClick={() => refDropzone.current.open()}
                    hideText={false}
                    disabled={isDisabled}
                />}

                {!autoUpload && filesExist && <Button
                    className="images-upload-button-cancel"
                    transId={textButtonDeleteFiles[0]}
                    onClick={() => onCancel()}
                    hideText={false}
                    disabled={isDisabled}
                />}

                {!autoUpload && filesAcceptedExist && <Button
                    className="images-upload-button-upload"
                    transId={textButtonUploadFiles[0]}
                    onClick={() => onUpload()}
                    hideText={false}
                    disabled={isDisabled}
                />}
            </div>
        </div>
    )
}

export default ImageUploadComponent